import React, { useContext } from 'react';
import { BuildContext } from '../../Data/Context/buildData';
import { DatabaseContext } from '../../Controllers/Database';
import { AppConfigContext } from '../../Config/App';
import { getUserFromLocalStorage } from '../../utils/localStorage';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../Data/Context/languageContext';
import parse from 'html-react-parser';

const SaveAndShare = () => {
    const user_session = getUserFromLocalStorage();

    const { buildData, buildDataFromDB } = useContext(BuildContext);
    const { processData } = useContext(DatabaseContext);
    const { uri_segment, navigate_to } = useContext(AppConfigContext);
    const { t } = useContext(LanguageContext);

    function onSaveBuild() {
        processData(buildData, 'create');
    }

    function onUpdateBuild() {
        processData(buildDataFromDB, 'update');
    }

    return (
        <div className="modal fade" role="dialog" tabIndex="-1" id="saveshare-modal">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="modal-body purple-bk-darker text-center">
                        {user_session
                            ?
                            <>
                                {parse(t("save_share_modal_session_true"))}
                                <button onClick={() => uri_segment(6) ? onUpdateBuild() : onSaveBuild()} className='btn btn-success m-2' type="button" data-bs-dismiss="modal"><i className="fa-solid fa-floppy-disk"></i> {t("save_build")}</button>
                            </>
                            :
                            <>
                                {parse(t("save_share_modal_session_false"))}
                                <Link to={navigate_to("auth")}>
                                    <button className='btn btn-primary m-2' type="button" data-bs-dismiss="modal">{t("login")} <i className="fa-solid fa-right-to-bracket"></i></button>
                                </Link>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SaveAndShare;